export const changePasswordActions = {
  changePasswordLoading: "CHANGE_PASSWORD_LOADING",
  changePasswordReady: "CHANGE_PASSWORD_READY"
};
